import { TENDERS_FILTER_DEFAULT } from '../../constants';
import { resolveUpdate } from './resolve';

export const createTendersSlice = (set) => ({
  // ── CRM / Appels d'offres (BOAMP) ──
  tenders: [],
  setTenders: (suivant) => set((etat) => ({ tenders: resolveUpdate(suivant, etat.tenders) })),
  tendersLoaded: false,
  setTendersLoaded: (suivant) =>
    set((etat) => ({ tendersLoaded: resolveUpdate(suivant, etat.tendersLoaded) })),
  tendersFilter: TENDERS_FILTER_DEFAULT,
  setTendersFilter: (suivant) =>
    set((etat) => ({ tendersFilter: resolveUpdate(suivant, etat.tendersFilter) })),
  tendersFilterOpen: null, // 'score' | 'statut' | null
  setTendersFilterOpen: (suivant) =>
    set((etat) => ({ tendersFilterOpen: resolveUpdate(suivant, etat.tendersFilterOpen) })),
  tenderEdit: null, // édition inline tableau : { idweb, field }
  setTenderEdit: (suivant) =>
    set((etat) => ({ tenderEdit: resolveUpdate(suivant, etat.tenderEdit) })),
  tenderUploadBusy: false, // import manuel de documents en cours (extraction + upload + analyse)
  setTenderUploadBusy: (suivant) =>
    set((etat) => ({ tenderUploadBusy: resolveUpdate(suivant, etat.tenderUploadBusy) })),
  tenderUploadIdweb: null, // idweb en cours d'import — un seul à la fois, permet de cibler l'icône de la bonne ligne
  setTenderUploadIdweb: (suivant) =>
    set((etat) => ({ tenderUploadIdweb: resolveUpdate(suivant, etat.tenderUploadIdweb) })),
  tenderUploadStepText: '',
  setTenderUploadStepText: (suivant) =>
    set((etat) => ({ tenderUploadStepText: resolveUpdate(suivant, etat.tenderUploadStepText) })),
  tenderUploadProgress: null, // 0..1 pendant extraction/envoi, null = étape indéterminée (analyse LLM)
  setTenderUploadProgress: (suivant) =>
    set((etat) => ({ tenderUploadProgress: resolveUpdate(suivant, etat.tenderUploadProgress) })),
});
